<template>
    <div>
        <el-form ref="form" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="配置表：" prop="selected">
                <ESelect v-model="formItem.selected" multiple filterable :disabled="isView" class="full-w" :loading="roleLoading" placeholder="请选择配置表">
                    <el-option
                        v-for="item in optionList"
                        :key="item.id"
                        :label="item.table_comment"
                        :value="item.id">
                        {{item.table_comment}}
                    </el-option>
                </ESelect>
            </el-form-item>
        </el-form>

        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div v-else class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ConfigOptionTableModal",
        props:{
            isView:{
                type: Boolean,
                default:false,
            },
            page:{
                type: Object,
                required: true
            },
            cbs:{
                type:Object,
            },
            optionList:Array,
        },
        data() {
            return {
                formItem: {
                    selected: [],
                },
                roleLoading:false,
            }
        },
        computed: {
        },
        mounted(){
            let optionalData = this.page.optional_config_table_val;
            if(optionalData&&optionalData.length>0){
                this.formItem.selected = optionalData.map(item=>item);
            }
        },
        methods: {
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.cbs.onSubmit(this.formItem);
                        this.handleClose();
                    } else {
                        return false;
                    }
                });
            },
        },

    }
</script>

<style scoped>

</style>
